import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//Import Icons
import FeatherIcon from "feather-icons-react";
import { useTranslation } from "react-i18next";
import { ROUTES } from "routes/allRoutes";
import ImgContent from "../assets/images/menu/content.png";
import ImgSticker from "../assets/images/menu/sticker.png";
import ImgUser from "../assets/images/menu/user.png";
import ImgBar from "../assets/images/menu/bar.png";
import ImgLog from "../assets/images/menu/log.svg";
import ImgAgency from "../assets/images/menu/agency.png";
import ImgCoupon from "../assets/images/menu/coupon.png";
import ImgSetting from "../assets/images/menu/setting.svg";
import ImgStatistic from "../assets/images/menu/statistic.svg";
import ImgNotification from "../assets/images/menu/notification.svg";
import ImgOperator from "../assets/images/menu/operator.svg";
import ImgHashtag from "../assets/images/menu/hashtag.png";
import ImgInquiry from "../assets/images/menu/inquiry.svg";
import ImgVOC from "../assets/images/menu/voc.svg";
import ImgReferral from "../assets/images/menu/referral.svg";
import ImgWithdraw from "../assets/images/menu/withdraw.png";

import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";
import { useRole } from "components/Hooks/UserHooks";

const Navdata = () => {
  const history = useNavigate();
  const { t } = useTranslation();

  const { userPermissions } = useRole();

  const [menuActive, setMenuActive] = useState<string>("DASHBOARD");

  // Multi Level
  const [isMultiLevel, setIsMultiLevel] = useState<boolean>(false);
  const [isLevel1, setIsLevel1] = useState<boolean>(false);
  const [isLevel2, setIsLevel2] = useState<boolean>(false);

  const [isCurrentState, setIsCurrentState] = useState("Dashboard");

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("sub-items");
        const getID = document.getElementById(id) as HTMLElement;
        if (getID) getID.classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
  }, [history]);

  const menuItems: any = [
    {
      id: "content-management",
      label: t("Content Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgContent}
          alt="Content Management"
          width={19}
          height={19}
        />
      ),
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "Feed");
        setIsCurrentState((prev) => "Feed");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "Feed",
      isShow: true,
      subItems: [
        // {
        //   id: "feed",
        //   label: t("Feed"),
        //   link: ROUTES.FEED,
        //   isShow: true,
        // },
        {
          id: "wink",
          label: t("Wink"),
          link: ROUTES.WINK,
          isShow: true,
        },
        {
          id: "sticker_management",
          label: t("Sticker"),
          link: ROUTES.STICKER_MANAGEMENT,
          isShow: true,
        },
        // {
        //   id: "chat-content",
        //   label: t("Chat Content"),
        //   link: ROUTES.CHAT_CONTENT,
        //   isShow: true,
        // },
      ],
    },

    {
      id: "user-management",
      label: t("User Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgUser}
          alt="User Management"
          width={20}
          height={20}
        />
      ),
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "User");
        setIsCurrentState((prev) => "User");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "User",
      isShow: true,
      subItems: [
        {
          id: "store-management",
          label: t("Menu Manager"),
          link: ROUTES.STORE_MANAGEMENT,
          isShow: true,
        },
        {
          id: "bartender-user-list",
          label: t("Bartender"),
          link: ROUTES.BARTENDER_USER_LIST,
          isShow: true,
        },
        {
          id: "customer",
          label: t("Menu User"),
          link: ROUTES.CUSTOMER,
          isShow: true,
        },
      ],
    },
    {
      id: "multilevel6",
      label: t("Operator Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgOperator}
          alt="Operator"
          width={20}
          height={20}
        />
      ),
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "USER");
        setIsCurrentState((prev) => "User");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "USER",
      isShow: true, // isHavePermissionRole([ROLES_FOR_APP.OPERATOR_LIST, ROLES_FOR_APP.ROLE_LIST, ROLES_FOR_APP.ACTIVITY_LOG_LIST], userPermissions),
      subItems: [
        {
          id: "user",
          label: t("Operator"),
          link: ROUTES.OPERATOR_LIST,
          isShow: isHavePermissionRole(
            ROLES_FOR_APP.OPERATOR_LIST,
            userPermissions
          ),
        },
        {
          id: "role-list",
          label: t("Role"),
          link: ROUTES.OPERATOR_ROLE,
          isShow: isHavePermissionRole(
            ROLES_FOR_APP.ROLE_LIST,
            userPermissions
          ),
        },
        {
          id: "activity-logs",
          label: t("Activity Logs"),
          link: ROUTES.OPERATOR_ACTIVITY_LOG,
          isShow: isHavePermissionRole(
            ROLES_FOR_APP.ACTIVITY_LOG_LIST,
            userPermissions
          ),
        },
      ],
    },

    {
      id: "bar-management",
      label: t("Store Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgBar}
          alt="Store Management"
          width={18}
          height={18}
        />
      ),
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "BarList");
        setIsCurrentState((prev) => "BarList");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "BarList",
      isShow: true,
      subItems: [
        {
          id: "bar-list",
          label: t("Store"),
          link: ROUTES.BAR_LIST,
          isShow: true,
        },
        {
          id: "hashtag_management",
          label: t("Hashtag"),
          link: ROUTES.HASHTAG_MANAGEMENT,
          isShow: true,
        },
        // {
        //   id: "reservation",
        //   label: t("Reservation Status"),
        //   link: ROUTES.RESERVATION_STATUS,
        //   isShow: true,
        // },
      ],
    },

    // {
    //   id: "ads-management",
    //   label: t("Ads Management"),
    //   icon: <img className="menu-custom__icon" src={ImgAds} alt="Ads Management" width={22} height={22} />,
    //   link: "/#",
    //   click: function (e: any) {
    //     e.preventDefault();
    //     setMenuActive((prev) => "Ads Management");
    //     setIsCurrentState((prev) => "Ads Management");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: menuActive === "Ads Management",
    //   isShow: true,
    //   subItems: [
    //     {
    //       id: "ad-package",
    //       label: t("Package"),
    //       link: ROUTES.AD_PACKAGE,
    //       isShow: true,
    //     },
    //     {
    //       id: "ad-list",
    //       label: t("Ads List"),
    //       link: ROUTES.AD_LIST,
    //       isShow: true,
    //     },
    //     {
    //       id: "boost-ad",
    //       label: t("Ads Boost"),
    //       link: ROUTES.BOOST_AD,
    //       isShow: true,
    //     },
    //   ],
    // },
    {
      id: "agency-management",
      label: t("Agency Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgAgency}
          alt="Agency Management"
          width={18}
          height={18}
        />
      ),
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "Agency");
        setIsCurrentState((prev) => "Agency");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "Agency",
      isShow: true,
      subItems: [
        {
          id: "agency",
          label: t("Agency"),
          link: ROUTES.AGENCY_LIST_MANAGEMENT,
          isShow: true,
        },
        {
          id: "campaign",
          label: t("Campaign"),
          link: ROUTES.AGENCY_CAMPAIGN,
          isShow: true,
        },
        {
          id: "install-management",
          label: t("Event Tracking Logs"),
          link: ROUTES.AGENCY_EVENT_TRACKING,
          isShow: true,
        },
      ],
    },
    {
      id: "coupon-management",
      label: t("Coupon Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgCoupon}
          alt="Coupon Management"
          width={20}
          height={20}
        />
      ),
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "Coupon");
        setIsCurrentState((prev) => "Coupon");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "Coupon",
      isShow: true,
      subItems: [
        {
          id: "coupon-issue",
          label: t("Coupon Issue"),
          link: ROUTES.COUPON_ISSUE,
          isShow: true,
        },
        {
          id: "coupon-action-log",
          label: t("Coupon Action Log"),
          link: ROUTES.COUPON_ACTION_LOG,
          isShow: true,
        },
      ],
    },

    {
      id: "inquiry",
      label: t("Inquiry Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgInquiry}
          alt="Inquiry Management"
          width={20}
          height={20}
        />
      ),
      link: ROUTES.INQUIRY_LIST,
      click: function (e: any) {
        setMenuActive((prev) => "Inquiry");
        setIsCurrentState((prev) => "Inquiry");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "Inquiry",
      isShow: true,
    },

    {
      id: "voc-management",
      label: t("VOC Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgVOC}
          alt="Notification"
          width={21}
          height={21}
        />
      ),
      link: "/#",
      isShow: true,
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "VOC Management");
        setIsCurrentState((prev) => "VOC Management");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "VOC Management",
      subItems: [
        {
          id: "voc-reason",
          label: t("VOC Reason"),
          link: ROUTES.VOC_REASON,
          isShow: true,
        },
        {
          id: "voc-list",
          label: t("VOC List"),
          link: ROUTES.VOC_LIST,
          isShow: true,
        },
      ],
    },
    {
      id: "referral-management",
      label: t("Friend Invitation Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgReferral}
          alt="Friend Invitation Management"
          width={20}
          height={20}
        />
      ),
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "referral-management");
        setIsCurrentState((prev) => "referral-management");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "referral-management",
      isShow: true,
      subItems: [
        {
          id: "referral_trigger_event",
          label: t("Reward Distribution Settings"),
          link: ROUTES.REFERRAL_TRIGGER_EVENT,
          isShow: true,
        },
        {
          id: "referral_rules",
          label: t("Invitation Rules"),
          link: ROUTES.REFERRAL_RULES,
          isShow: true,
        },
        {
          id: "referral_rewards",
          label: t("Invitation Reward Details"),
          link: ROUTES.REFERRAL_REWARDS,
          isShow: true,
        },
        {
          id: "referral_request-withdraw",
          label: t("Request Withdraw"),
          link: ROUTES.REQUEST_WITHDRAW,
          isShow: true,
        },
      ],
    },
    // {
    //   id: "request-withdraw",
    //   label: t("Request Withdraw"),
    //   icon: (
    //     <img
    //       className="menu-custom__icon"
    //       src={ImgWithdraw}
    //       alt="Request Withdraw"
    //       width={20}
    //       height={20}
    //     />
    //   ),
    //   link: ROUTES.REQUEST_WITHDRAW,
    //   click: function (e: any) {
    //     setMenuActive((prev) => "Request Withdraw");
    //     setIsCurrentState((prev) => "Request Withdraw");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: menuActive === "Request Withdraw",
    //   isShow:
    //     !!window.location.href.includes("dev") ||
    //     !!window.location.href.includes("localhost"),
    // },
    {
      id: "push-notification",
      label: t("Push Notification"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgNotification}
          alt="Notification"
          width={21}
          height={21}
        />
      ),
      link: "/#",
      isShow: true,
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "Push Notification");
        setIsCurrentState((prev) => "Push Notification");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "Push Notification",
      subItems: [
        {
          id: "push-log",
          label: t("Push Log"),
          link: ROUTES.PUSH_NOTIFICATION_PUSH_LOG,
          isShow: true,
        },
        {
          id: "manual-push",
          label: t("Send Push (Manual)"),
          link: ROUTES.PUSH_NOTIFICATION_MANUAL_PUSH,
          isShow: true,
        },
      ],
    },

    {
      id: "multilevel",
      label: "Statistics",
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgStatistic}
          alt="Statistic"
          width={20}
          height={20}
        />
      ),
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        // setIsMultiLevel(!isMultiLevel);
        setMenuActive((prev) => "Statistics");
        setIsCurrentState("Statistics");
        updateIconSidebar(e);
      },
      isShow: true,
      stateVariables: menuActive === "Statistics",
      subItems: [
        {
          id: "acquisition-statistics",
          label: t("Acquisition Statistics"),
          link: ROUTES.STATISTICS_ACQUISITION,
          isShow: true,
        },
        {
          id: "daily-statistics",
          label: t("Daily Statistics"),
          link: ROUTES.STATISTICS_DAILY_USER,
          parentId: "multilevel",
          isShow: true,
        },
        {
          id: "regional-city-statistics",
          label: t("Regional Statistics (City)"),
          link: ROUTES.STATISTICS_REGIONAL_CITY,
          isShow: true,
        },
        {
          id: "regional-town-statistics",
          label: t("Regional Statistics (Town)"),
          link: ROUTES.STATISTICS_REGIONAL_TOWN,
          isShow: true,
        },
        {
          id: "bar-statistics",
          label: t("Store Statistics"),
          link: ROUTES.STATISTICS_BAR,
          parentId: "multilevel",
          isShow: true,
        },
        {
          id: "push-statistics",
          label: t("Push Statistics"),
          link: ROUTES.STATISTICS_PUSH,
          parentId: "multilevel",
          isShow: true,
        },
      ],
    },
    {
      id: "log-management",
      label: t("Log"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgLog}
          alt="Location Log"
          width={20}
          height={20}
        />
      ),
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "LogList");
        setIsCurrentState((prev) => "LogList");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "LogList",
      isShow: true,
      subItems: [
        {
          id: "location_log",
          label: t("Location Log"),
          link: ROUTES.LOCATION_LOG,
          isShow: true,
        },
        {
          id: "event_log",
          label: t("Event Log"),
          link: ROUTES.EVENT_LOG,
          isShow: true,
        },
        {
          id: "chat_log",
          label: t("Chat Log"),
          link: ROUTES.CHAT_LOG,
          isShow: true,
        },
        {
          id: "referral_log",
          label: t("Referral Log"),
          link: ROUTES.REFERRAL_LOG,
          isShow: true,
        },
      ],
    },
    {
      id: "setting-management",
      label: t("Setting Management"),
      icon: (
        <img
          className="menu-custom__icon"
          src={ImgSetting}
          alt="Setting"
          width={20}
          height={20}
        />
      ),
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "setting-management");
        setIsCurrentState((prev) => "setting-management");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "setting-management",
      isShow: true,
      subItems: [
        {
          id: "app_setting",
          label: t("App Setting"),
          link: ROUTES.APP_SETTING,
          isShow: true,
        },
      ],
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
